import { CodeListInput } from './CodeListInput';
import { CurrencySelect } from './CurrencySelect';
import { useCurrencies } from '@/hooks/useCurrencies';

export interface CurrencyListInputProps {
  /** La liste telle qu'elle est stockee : un tableau de codes ISO. */
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  id?: string;
}

/**
 * Liste de devises choisies dans le menu ordinaire (#229).
 *
 * Le referentiel vient de la base du webapp — c'est bien
 * plus etroit que les pays, et une saisie libre y acceptait `XYZ` sans rien
 * dire.
 */
export function CurrencyListInput({
  value,
  onChange,
  placeholder = 'Add a currency…',
  error,
  disabled,
  id,
}: CurrencyListInputProps) {
  const { currencies } = useCurrencies();
  const labelByCode = new Map(currencies.map((c) => [c.code, `${c.code} — ${c.name}`]));
  return (
    <CodeListInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      id={id}
      labelFor={(code) => labelByCode.get(code)}
      picker={(add) => (
        <CurrencySelect
          id={id}
          value={undefined}
          onChange={add}
          placeholder={placeholder}
          error={error}
          disabled={disabled}
        />
      )}
    />
  );
}
